import { render } from "./ImageGeneration.vue?vue&type=template&id=c7f4488e&scoped=true"
import script from "./ImageGeneration.vue?vue&type=script&lang=js"
export * from "./ImageGeneration.vue?vue&type=script&lang=js"

import "./ImageGeneration.vue?vue&type=style&index=0&id=c7f4488e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7f4488e"]])

export default __exports__